module.exports = __webpack_public_path__ + "static/media/card.c23ed863.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/dallas/card.jpg
// module id = 914
// module chunks = 27